// extracted by mini-css-extract-plugin
export default {"title":"Contact_title__a0xQo","text":"Contact_text__o4cee","email":"Contact_email__keNDJ"};